import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot from React 18
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "./components/hooks/store";
import { PersistGate } from "redux-persist/integration/react";
import UserProvider from "./components/shared/utils/userProvider";
import { BrowserRouter } from "react-router-dom"; // Add BrowserRouter here
import { createBrowserHistory } from "history";

const history = createBrowserHistory();
const container = document.getElementById("root");
const root = createRoot(container); // Create the root using createRoot

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <UserProvider>
        <BrowserRouter history={history}>
          <App />
        </BrowserRouter>
      </UserProvider>
    </PersistGate>
  </Provider>
);

reportWebVitals();
